import {UserDetail} from '@/entities/user'

export interface NoticesEntity {
    received: IMessage[]
    sent: IMessage[]
    composer: IComposer
    recipients: IRecipient[] // all recipients
}

export interface IMessage {
    id: number
    message: string
    type: string
    created: number
    scheduled_at: number
    friendly_scheduled_at?: string
    user_id: number
    recipients: IMessageRecipient[], // who this message is sent to
    seen: number // for received msg
    noticesrecipient_id: number // for recived msg recipient id
    sender: UserDetail
    actions: {
        up: number
        down: number
        think: number
        raise_hands: number
        celebrate: number
        feedback: number
    },
    virtual_from?: number
    daily_check_in_data?: IDailyCheckIn
    recipient_count?: number
    feedback?: []
}

export interface IMessageRecipient {
    user_id: number
    seen: number
    sent: number
    type: 'group' | 'user'
    field: string
    value: string
    role: string
    name: string // the name of user who this msg is sent to if type is user
}

export interface IComposer {
    recipients: IRecipient[]
    message: string
    mentions: IRecipient[]
    scheduled_at: string
    type: string
    question: {
        id: number
        comment: string
    } | null // optional question the notice is related to
}

export interface IRecipient {
    type: 'user' | 'group' | 'virtual'
    name: string // name to display
    description: string
    user_id: number // id of user or 0 for group
    field: string // field for group type or empty for user type
    value: string // value for group type or empty for user type
    role: string // role for group+role or empty for user type
    avatar: string
    usernames: string[] // value for group type, usernames under the group
    selectableForSending?: boolean // value if this user can be selected as a sender
}

export interface INoticeType {
    name: string
    emergencyLevel: number
    description: string
    eg: string
    color: string
    backgroundColor: string
    confetti: number,
    allowedRespondActions: NoticeRespondAction
    icon: string
    isComposing: boolean
}

export interface IDailyCheckIn {
    updateNotice: IMessage | null
    feedback: IDailyCheckInFeedback
    dailyCheckInOption: IDailyCheckInOption
    answer?: string
}

export interface IDailyCheckInOption {
    id: number
    question: string
    type: 'select' | 'nps' | 'emoji'
    values?: []
    options?: []
}

export interface IDailyCheckInFeedback {
    userType: 'frontline_staff' | 'frontline_manager'
    yesterdayNps: number
    twoDaysAgoNps: number
    areas: []
}

export enum NoticeRespondAction {
    Down = 1 << 0,       // 000001
    Think = 1 << 1,      // 000010
    Up = 1 << 2,         // 000100
    RaiseHands = 1 << 3, // 001000
    Celebrate = 1 << 4,  // 010000
    Feedback = 1 << 5,   // 100000
    All = Down | Think | Up | RaiseHands | Celebrate | Feedback
}

export const NOTICE_REACTION_TYPES:{ [key: string]: string } = {
    'down': '🤷‍♀',
    'think': '🤔',
    'up': '👍',
    'raise_hands': '🙌',
    'celebrate': '🎉',
}

export const unknownUser : IRecipient = {
    type: 'user',
    name: 'Unknown User',
    description: '',
    user_id: 0,
    field: '',
    value: '',
    role: '',
    avatar: '',
    usernames: []
}
